// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa1fb8d8","453":"1b7f51d0","455":"dccd1c0a","867":"73ea55b1"}[chunkId] + ".chunk.js";
};